import { Injectable } from '@angular/core';
import { OidcSecurityCommon } from './oidc.security.common';

import { KJUR, KEYUTIL, hextob64u } from 'jsrsasign';
export class OidcSecurityValidation {
/**
 * @param {?} oidcSecurityCommon
 */
constructor(private oidcSecurityCommon: OidcSecurityCommon) {
    }
/**
 * @param {?} token
 * @param {?=} offsetSeconds
 * @return {?}
 */
isTokenExpired(token: string, offsetSeconds?: number): boolean {

        let /** @type {?} */ decoded: any;
        decoded = this.getPayloadFromToken(token, false);

        return !(this.validate_id_token_exp_not_expired(decoded, offsetSeconds));
    }
/**
 * @param {?} decoded_id_token
 * @param {?=} offsetSeconds
 * @return {?}
 */
validate_id_token_exp_not_expired(decoded_id_token: string, offsetSeconds?: number): boolean {
        let /** @type {?} */ tokenExpirationDate = this.getTokenExpirationDate(decoded_id_token);
        offsetSeconds = offsetSeconds || 0;

        if (tokenExpirationDate == null) {
            return false;
        }

        // Token not expired?
        return (tokenExpirationDate.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
    }
/**
 * @param {?} dataIdToken
 * @return {?}
 */
validate_required_id_token(dataIdToken: any): boolean {

        let /** @type {?} */ validated = true;
        if (!dataIdToken.hasOwnProperty('iss')) {
            validated = false;
            this.oidcSecurityCommon.logWarning('iss missing, validatation REQUIRED prorpeties in id_token');
        }

        if (!dataIdToken.hasOwnProperty('sub')) {
            validated = false;
            this.oidcSecurityCommon.logWarning('sub missing, validatation REQUIRED prorpeties in id_token');
        }

        if (!dataIdToken.hasOwnProperty('aud')) {
            validated = false;
            this.oidcSecurityCommon.logWarning('aud missing, validatation REQUIRED prorpeties in id_token');
        }

        if (!dataIdToken.hasOwnProperty('exp')) {
            validated = false;
            this.oidcSecurityCommon.logWarning('exp missing, validatation REQUIRED prorpeties in id_token');
        }

        if (!dataIdToken.hasOwnProperty('iat')) {
            validated = false;
            this.oidcSecurityCommon.logWarning('iat missing, validatation REQUIRED prorpeties in id_token');
        }

        return validated;
    }
/**
 * @param {?} dataIdToken
 * @param {?} max_offset_allowed_in_seconds
 * @return {?}
 */
validate_id_token_iat_max_offset(dataIdToken: any, max_offset_allowed_in_seconds: number): boolean {
        if (!dataIdToken.hasOwnProperty('iat')) {
            return false;
        }

        let /** @type {?} */ dateTime_iat_id_token = new Date(0); // The 0 here is the key, which sets the date to the epoch
        dateTime_iat_id_token.setUTCSeconds(dataIdToken.iat);

        max_offset_allowed_in_seconds = max_offset_allowed_in_seconds || 0;

        if (dateTime_iat_id_token == null) {
            return false;
        }

        this.oidcSecurityCommon.logDebug('validate_id_token_iat_max_offset: ' + (new Date().valueOf() - dateTime_iat_id_token.valueOf()) + ' < ' + (max_offset_allowed_in_seconds * 1000));
        return ((new Date().valueOf() - dateTime_iat_id_token.valueOf()) < (max_offset_allowed_in_seconds * 1000));
    }
/**
 * @param {?} dataIdToken
 * @param {?} local_nonce
 * @return {?}
 */
validate_id_token_nonce(dataIdToken: any, local_nonce: any): boolean {
        if (dataIdToken.nonce !== local_nonce) {
            this.oidcSecurityCommon.logDebug('Validate_id_token_nonce failed, dataIdToken.nonce: ' + dataIdToken.nonce + ' local_nonce:' + local_nonce);
            return false;
        }

        return true;
    }
/**
 * @param {?} dataIdToken
 * @param {?} authWellKnownEndpoints_issuer
 * @return {?}
 */
validate_id_token_iss(dataIdToken: any, authWellKnownEndpoints_issuer: any): boolean {
        if (dataIdToken.iss !== authWellKnownEndpoints_issuer) {
            this.oidcSecurityCommon.logDebug('Validate_id_token_iss failed, dataIdToken.iss: ' + dataIdToken.iss + ' authWellKnownEndpoints issuer:' + authWellKnownEndpoints_issuer);
            return false;
        }

        return true;
    }
/**
 * @param {?} dataIdToken
 * @param {?} aud
 * @return {?}
 */
validate_id_token_aud(dataIdToken: any, aud: any): boolean {
        if (dataIdToken.aud !== aud) {
            this.oidcSecurityCommon.logDebug('Validate_id_token_aud failed, dataIdToken.aud: ' + dataIdToken.aud + ' client_id:' + aud);
            return false;
        }

        return true;
    }
/**
 * @param {?} state
 * @param {?} local_state
 * @return {?}
 */
validateStateFromHashCallback(state: any, local_state: any): boolean {
        if (state !== local_state) {
            this.oidcSecurityCommon.logDebug('ValidateStateFromHashCallback failed, state: ' + state + ' local_state:' + local_state);
            return false;
        }

        return true;
    }
/**
 * @param {?} id_token_sub
 * @param {?} userdata_sub
 * @return {?}
 */
validate_userdata_sub_id_token(id_token_sub: any, userdata_sub: any): boolean {
        if (id_token_sub !== userdata_sub) {
            this.oidcSecurityCommon.logDebug('validate_userdata_sub_id_token failed, id_token_sub: ' + id_token_sub + ' userdata_sub:' + userdata_sub);
            return false;
        }

        return true;
    }
/**
 * @param {?} token
 * @param {?} encode
 * @return {?}
 */
getPayloadFromToken(token: any, encode: boolean) {
        let /** @type {?} */ data = {};
        if (typeof token !== 'undefined') {
            let /** @type {?} */ encoded = token.split('.')[1];
            if (encode) {
                return encoded;
            }
            data = JSON.parse(this.urlBase64Decode(encoded));
        }

        return data;
    }
/**
 * @param {?} token
 * @param {?} encode
 * @return {?}
 */
getHeaderFromToken(token: any, encode: boolean) {
        let /** @type {?} */ data = {};
        if (typeof token !== 'undefined') {
            let /** @type {?} */ encoded = token.split('.')[0];
            if (encode) {
                return encoded;
            }
            data = JSON.parse(this.urlBase64Decode(encoded));
        }

        return data;
    }
/**
 * @param {?} token
 * @param {?} encode
 * @return {?}
 */
getSignatureFromToken(token: any, encode: boolean) {
        let /** @type {?} */ data = {};
        if (typeof token !== 'undefined') {
            let /** @type {?} */ encoded = token.split('.')[2];
            if (encode) {
                return encoded;
            }
            data = JSON.parse(this.urlBase64Decode(encoded));
        }

        return data;
    }
/**
 * @param {?} id_token
 * @param {?} jwtkeys
 * @return {?}
 */
validate_signature_id_token(id_token: any, jwtkeys: any): boolean {

        if (!jwtkeys || !jwtkeys.keys) {
            return false;
        }

        let /** @type {?} */ header_data = this.getHeaderFromToken(id_token, false);

        // Accepts ID Token without 'kid' claim in JOSE header if only one JWK supplied in 'jwks_url'
        if (!this.validate_no_kid_in_header_only_one_allowed_in_jwtkeys(header_data, jwtkeys)) {
            this.oidcSecurityCommon.logWarning('no ID Token kid claim in JOSE header and multiple supplied in jwks_uri');
            return false;
        }

        let /** @type {?} */ kid = header_data.kid;
        let /** @type {?} */ alg = header_data.alg;

        if ('RS256' != alg) {
            this.oidcSecurityCommon.logWarning('Only RS256 supported');
            return false;
        }

        let /** @type {?} */ isValid = false;

        if (!header_data.hasOwnProperty('kid')) {
            // exactly 1 key in the jwtkeys and no kid in the Jose header
            for (let /** @type {?} */ key of jwtkeys.keys) {
                let /** @type {?} */ publickey = KEYUTIL.getKey(key);
                isValid = KJUR.jws.JWS.verify(id_token, publickey, ['RS256']);
                if (!isValid) {
                    this.oidcSecurityCommon.logWarning('incorrect Signature, validation failed for id_token');
                }
                return isValid;
            }
        } else {
            // kid in the Jose header of id_token
            for (let /** @type {?} */ key of jwtkeys.keys) {
                if (key.kid === kid) {
                    let /** @type {?} */ publickey = KEYUTIL.getKey(key);
                    isValid = KJUR.jws.JWS.verify(id_token, publickey, ['RS256']);
                    if (!isValid) {
                        this.oidcSecurityCommon.logWarning('incorrect Signature, validation failed for id_token');
                    }
                    return isValid;
                }
            }
        }

        return isValid;
    }
/**
 * @param {?} response_type
 * @return {?}
 */
config_validate_response_type(response_type: string): boolean {
        if (response_type === 'id_token token' || response_type === 'id_token') {
            return true;
        }

        this.oidcSecurityCommon.logWarning('module configure incorrect, invalid response_type:' + response_type);
        return false;
    }
/**
 * @param {?} header_data
 * @param {?} jwtkeys
 * @return {?}
 */
private validate_no_kid_in_header_only_one_allowed_in_jwtkeys(header_data: any, jwtkeys: any): boolean {
        this.oidcSecurityCommon.logDebug('amount of jwtkeys.keys: ' + jwtkeys.keys.length);
        if (!header_data.hasOwnProperty('kid')) {
            // no kid defined in Jose header
            if (jwtkeys.keys.length != 1) {
                this.oidcSecurityCommon.logDebug('jwtkeys.keys.length != 1 and no kid in header');
                return false;
            }
        }

        return true;
    }
/**
 * @param {?} access_token
 * @param {?} at_hash
 * @return {?}
 */
validate_id_token_at_hash(access_token: any, at_hash: any): boolean {

        let /** @type {?} */ hash = KJUR.crypto.Util.hashString(access_token, 'sha256');
        let /** @type {?} */ first128bits = hash.substr(0, hash.length / 2);
        let /** @type {?} */ testdata = hextob64u(first128bits);

        if (testdata === at_hash) {
            return true; // isValid;
        }

        return false;
    }
/**
 * @param {?} dataIdToken
 * @return {?}
 */
private getTokenExpirationDate(dataIdToken: any): Date {
        if (!dataIdToken.hasOwnProperty('exp')) {
            return new Date();
        }

        let /** @type {?} */ date = new Date(0); // The 0 here is the key, which sets the date to the epoch
        date.setUTCSeconds(dataIdToken.exp);

        return date;
    }
/**
 * @param {?} str
 * @return {?}
 */
private urlBase64Decode(str: string) {
        let /** @type {?} */ output = str.replace('-', '+').replace('_', '/');
        switch (output.length % 4) {
            case 0:
                break;
            case 2:
                output += '==';
                break;
            case 3:
                output += '=';
                break;
            default:
                throw 'Illegal base64url string!';
        }

        return window.atob(output);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OidcSecurityCommon, },
];
}

function OidcSecurityValidation_tsickle_Closure_declarations() {
/** @type {?} */
OidcSecurityValidation.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OidcSecurityValidation.ctorParameters;
/** @type {?} */
OidcSecurityValidation.prototype.oidcSecurityCommon;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
